import { api } from './client';

export interface NoteImage {
  id: string;
  originalName: string;
  size: number;
  mimeType: string;
  width: number | null;
  height: number | null;
  createdAt: string;
}

export interface ClientNote {
  id: string;
  clientId: number;
  text: string;
  createdBy: {
    id: string;
    firstName: string;
    lastName: string;
  };
  createdAt: string;
  updatedBy: {
    id: string;
    firstName: string;
    lastName: string;
  } | null;
  updatedAt: string;
  isArchived: boolean;
  images: NoteImage[];
}

// Fetch image as blob with auth
export async function fetchImageBlob(
  clientId: number,
  noteId: string,
  imageId: string,
  thumb = false,
): Promise<Blob> {
  const url = `/clients/${clientId}/notes/${noteId}/images/${imageId}${thumb ? '?thumb=1' : ''}`;
  const response = await api.get(url, { responseType: 'blob' });
  return response.data;
}

export const clientNotesApi = {
  getNotes: (clientId: number) =>
    api.get<ClientNote[]>(`/clients/${clientId}/notes`).then((r) => r.data),

  createNote: (clientId: number, text: string) =>
    api.post<ClientNote>(`/clients/${clientId}/notes`, { text }).then((r) => r.data),

  updateNote: (clientId: number, noteId: string, text: string) =>
    api.patch<ClientNote>(`/clients/${clientId}/notes/${noteId}`, { text }).then((r) => r.data),

  archiveNote: (clientId: number, noteId: string) =>
    api.post(`/clients/${clientId}/notes/${noteId}/archive`).then((r) => r.data),

  uploadImages: (clientId: number, noteId: string, files: File[]) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    return api
      .post<NoteImage[]>(`/clients/${clientId}/notes/${noteId}/images`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data);
  },

  deleteImage: (clientId: number, noteId: string, imageId: string) =>
    api.delete(`/clients/${clientId}/notes/${noteId}/images/${imageId}`).then((r) => r.data),
};
